import { User } from "lucide-react";

export function Avatar({ user, size = 40, className = "" }) {
  const url = user?.avatar_url
    ? (user.avatar_url.startsWith("http") ? user.avatar_url : `${process.env.REACT_APP_BACKEND_URL}${user.avatar_url}`)
    : null;
  const initials = `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`.toUpperCase() || "S";
  const style = { width: size, height: size };
  if (url) {
    return <img src={url} alt={initials} style={style} className={`rounded-full object-cover border-2 border-[#FFD60A]/40 ${className}`} data-testid="user-avatar" />;
  }
  return (
    <div style={style} className={`rounded-full bg-[#FFD60A] text-black font-heading font-black flex items-center justify-center border-2 border-[#FFD60A]/40 ${className}`} data-testid="user-avatar">
      <span style={{ fontSize: size * 0.4 }}>{initials}</span>
    </div>
  );
}
